module.exports = __webpack_public_path__ + "img/invoice-de-female-ni.f8787c34.png";